import React, { useEffect, useState } from 'react';
import { Table, Pagination, message, Button, Modal, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../../config/apiConfig';
import moment from 'moment';
import tokenStore from '../../stores/TokenStore';

const SettlementList = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // Change pageSize to 10
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSettlements(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize]);

  const fetchSettlements = async (pageNum, pageSize) => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}/settlement/select_settlement_page`, {
        pageNum,
        pageSize,
        notZero: 1
      });
      const { code, msg, data } = response.data;
      if (code === 200) {
        setData(data.list);
        setPagination({
          current: data.pageNum,
          pageSize: data.pageSize,
          total: data.total,
        });
      } else {
        message.error(msg || 'Data loading failed');
      }
    } catch (error) {
      message.error('Request failed');
    }
    setLoading(false);
  };

  const confirmPayout = (settlementId) => {
    Modal.confirm({
      title: 'Confirm Payout',
      content: 'Are you sure you want to proceed with the payout?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handlePayout(settlementId),
    });
  };

  const handlePayout = async (settlementId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/settlement/payout_settlement`,
        { settlementId },
        {
          headers: {
            token: tokenStore.token,
          },
        }
      );
      const { code, msg } = response.data;
      if (code === 200) {
        message.success('Payout successful');
        fetchSettlements(pagination.current, pagination.pageSize); // Refresh the data
      } else {
        message.error(msg || 'Payout failed');
      }
    } catch (error) {
      message.error('Payout request failed');
    }
    setLoading(false);
  };

  const columns = [
    { title: 'Merchant', dataIndex: 'merchantName', key: 'merchantName' },
    //返回数据Name为Batch No.
    { title: 'Batch No.', dataIndex: 'name', key: 'name' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (text) => <Tag color={text === 'COMPLETED' ? 'success' : 'warning'}>{text}</Tag> },
    { title: 'Amount', dataIndex: 'amount', key: 'amount', render: (text) => `${(text / 100).toFixed(2)}` },
    { title: 'Service Fee', dataIndex: 'serviceAmount', key: 'serviceAmount', render: (text) => `${(text / 100).toFixed(2)}` },
    { title: 'Subtotal', dataIndex: 'subtotalAmount', key: 'subtotalAmount', render: (text) => `${(text / 100).toFixed(2)}` },
    //settlement due date
    { title: 'Settlement Due Date', dataIndex: 'settlementTime', key: 'settlementTime', render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss') },
    { title: 'Start Time', dataIndex: 'payTimeStart', key: 'payTimeStart', render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss') },
    { title: 'End Time', dataIndex: 'payTimeEnd', key: 'payTimeEnd', render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss') },
    { title: 'Create Time', dataIndex: 'createTime', key: 'createTime', render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss') },
    {
      title: 'Detail',
      key: 'detail',
      render: (text, record) => (
        <Button type="link" onClick={() => navigate(`/settlement/detail/${record.id}`)}>
          Detail
        </Button>
      ),
    },
    {
      title: 'Payout',
      key: 'payout',
      render: (text, record) => (
        <Button
          type="primary"
          onClick={() => confirmPayout(record.id)}
          disabled={record.status !== 'PENDING'} // Enable the button based on your status condition
        >
          Payout
        </Button>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    fetchSettlements(pagination.current, pagination.pageSize);
  };

  return (
    <div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default SettlementList;
